import {QuizConfig} from '@/global/types/quiz';

const equipment: QuizConfig = {
    options: {
        page: {
            text: ['title', 'description', 'text', 'info', 'afterComponents']
        }
    },
    types: {
        dropdown: 'dropdown',
        collection: 'collection',
        textbox: 'textbox',
        textarea: 'textarea'
    },
    pages: [
        {
            id: null,
            allowedVersion: ['1.0', '1.1'],
            title: 'title',
            components: [{name: 'country'}],
        }
    ],
    components: {
        country: {
            type: 'dropdown',
            wrapperCssClass: 'offset-md-3 col-md-6',
            options: {
                source: 'store',
                target: 'db/countries/items',
                value: 'alpha3',
                name: 'name',
                filter: 'quiz_filter_countries'
            },
            validation: {
                required: true
            },
            payload: {
                field: 'country'
            }
        }
    }
}

export default equipment
